module.exports = __webpack_public_path__ + "img/taste-pc.91925fe9.png";